export const homeEnLocale = {
  'home.title': 'Welcome to Smart Ticket',
  'home.access': 'Your access to the',
  'home.spectacular': 'spectacular',
  'home.amazing': 'amazing',
  'home.unique': 'unique',
  'home.incredible': 'incredible',
  'home.findEvents': 'Find events',
  'home.description':
    'Find your favorite events in {country}, buy your tickets and enjoy the best experiences.',
  'home.buyTickets': 'Tickets',

  'home.date': 'Date',
  'home.time': 'Time',
  'home.location': 'Location',

  'home.seoTitle': 'Smart Ticket {country} - Book tickets for the best events',
  'home.seoDescription':
    'Discover and book tickets for the best events in {country}. Explore concerts, sports, theater, family activities, and unforgettable experiences near you.',

  'home.noEvents': 'No Events Available',
  'home.noEventsDescription':
    'It looks like there are no upcoming events at the moment. Check back later for exciting new listings!',
  'home.noEventsTeam':
    'Our team is working hard to bring you the best events. Stay tuned!',

  'home.soldOut': 'Sold out',
  'home.comingSoon': 'Coming soon',
  'home.boxOffice': 'Only box office',
  'home.cancelled': 'Cancelled',
  'home.preSale': 'Pre-sale',
} as const;

export const homeEsLocale = {
  'home.title': 'Bienvenido a Smart Ticket',
  'home.access': 'Tu acceso a lo',
  'home.spectacular': 'espectacular',
  'home.amazing': 'increíble',
  'home.unique': 'único',
  'home.incredible': 'asombroso',
  'home.findEvents': 'Buscar eventos',
  'home.description':
    'Encuentra tus eventos favoritos en {country}, compra tus boletos y disfruta de las mejores experiencias.',
  'home.buyTickets': 'Tickets',

  'home.date': 'Fecha',
  'home.time': 'Hora',
  'home.location': 'Lugar',

  'home.seoTitle':
    'Smart Ticket {country} - Compra boletos para los mejores eventos',
  'home.seoDescription':
    'Descubre y compra boletos para los mejores eventos en LATAM. Explora conciertos, deportes, teatro, eventos familiares y experiencias inolvidables cerca de ti.',

  'home.noEvents': 'No hay eventos disponibles',
  'home.noEventsDescription':
    'Parece que no hay eventos próximos en este momento. ¡Vuelve más tarde para ver nuevas listas emocionantes!',
  'home.noEventsTeam':
    '¡Nuestro equipo está trabajando arduamente para traerte los mejores eventos. ¡Mantente atento!',

  'home.soldOut': 'Agotado',
  'home.comingSoon': 'Próximamente',
  'home.boxOffice': 'Solo taquilla',
  'home.cancelled': 'Cancelado',
  'home.preSale': 'Preventa',
} as const;
